<!-- TODO this component can be put in common with ObjectCustomerCard and InterventionInvoiceCard and InterventionQuoteCard -->
<template>
  <div class="card">
    <div class="card-header">
      <span class="title" style="margin-right: 5px;">
        Facture
      </span>
      <button
        v-if="modelValue && !editing"
        class="small-tool-btn"
        style="margin-left: 5px;"
        @click="gotoInvoice">
        <i class="bi bi-eye" />
      </button>
      <button
        v-if="!editing"
        class="small-tool-btn"
        style="margin-left: 5px;"
        @click="startEditing">
        <i class="bi bi-pencil-square" />
      </button>
    </div>

    <div v-if="editing" class="card-body">
      <div class="form-group">
        <SelectObject
          placeholder="Assigner une facture à cette intervention"
          type="invoice"
          :selectedValue="selectedInvoice ? selectedInvoice.ref : null"
          @unselect="selectedInvoice = null" 
          @select="onInvoiceSelected" />
      </div>
      <div style="display: flex; justify-content: flex-end;">
        <button class="btn-primary" :disabled="savingInvoice" @click="endEditing">
          Annuler
        </button>
        <button
          class="btn-primary"
          :class="{ 'loading': savingInvoice }"
          style="margin-left: 5px;"
          :disabled="selectedInvoice?.id == modelValue?.id || savingInvoice"
          @click="saveInvoice">
          Enregistrer
        </button>
      </div>
    </div>

    <div v-else-if="modelValue" class="card-body">
      <InvoiceCompactRow
        :object="modelValue" />
    </div>
    
    <div v-else class="card-body">
      <i>Aucune</i>
    </div>
  </div>
</template>

<script>

import SelectObject from "@/components/inputs/SelectObject.vue";
import InvoiceCompactRow from "@/components/rows/invoice/InvoiceCompactRow.vue";

export default {
  name: "InterventionInvoiceCard",
  components: {
    SelectObject,
    InvoiceCompactRow,
  },
  props: {
    modelValue: {
      type: Object,
      required: false,
      default: null,
    },
    interventionId: {
      type: Number,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      editing: false,
      selectedInvoice: null,
      savingInvoice: false,
    };
  },
  methods: {
    gotoInvoice() {
      this.$router.push({ name: "invoice", params: { id: this.modelValue.id }});
    },
    startEditing() {
      this.selectedInvoice = this.modelValue,
      this.savingInvoice = false;
      this.editing = true;
    },
    onInvoiceSelected(invoice) {
      this.selectedInvoice = invoice;
    },
    saveInvoice() {
      if (this.selectedInvoice == null) {
        const res = window.confirm("Etes-vous sûr de vouloir n'assigner aucune facture à cette intervention ?");

        if (!res) {
          return;
        }
      }

      this.savingInvoice = true;

      this.$services.intervention.patch(
        this.interventionId,
        {
          invoice_id: this.selectedInvoice ? this.selectedInvoice.id : null,
        },
      ).then((response) => {
        this.$emit(
          "update:modelValue",
          response.data.invoice,
        );
        this.endEditing();
        
      }).finally(() => {
        this.savingInvoice = false;
      });
    },
    endEditing() {
      this.editing = false;
    },
  },
};

</script>